
import React from 'react';
import DataTable from "react-data-table-component";
import api from './api';
import './Doctors.css';
//import Users from './Users';
//import ListUsers from './ListUsers';
//import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { FaEdit, FaBan, FaTrash, FaCheck } from "react-icons/fa";
import useAuth from "../hooks/useAuth";

import {
    useState,
    useEffect
} from 'react';
import FloatingChatBot from './FloatingChatBot';
import Chat from './Chat';

const Staff = () => {
      const { auth } = useAuth();
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ username: '', password: "", 
        age: '', branch: "", designation: '',
        gender: '', status: "inactive", address: "", number: "", roles: ["therapist"] });

  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [roles, setRoles] = useState([]);
      const [branches, setBranches] = useState([]);
      const [sendUpdate, setSendUpdate] = useState(false);
const [chatOpen, setChatOpen] = useState(false);

    useEffect(
      () => {
          api.get(`${process.env.REACT_APP_URL}/users/all`)
              .then(response => { 
                //console.log("from mongo fetch",response.data);
                setUsers(response.data);
                getBranches();
              })
              .catch(error =>
                  console.error('Error fetching users:', error));
      }, []);

      

   const getBranches = () => {
           
         api.get(`${process.env.REACT_APP_URL}/branches`)
                  .then(response => { 
                    //console.log("from mongo fetch",response.data);
                    setBranches(response.data);
                    getRoles();
                    })
                    .catch(error =>
                        console.error('Error fetching patients:', error));   
  }

   const getRoles = () => {
           
        api.get(`${process.env.REACT_APP_URL}/roles`)
              .then(response => { 
                //console.log("from mongo fetch",response.data);
                setRoles(response.data)
              })
              .catch(error =>
                  console.error('Error fetching roles:', error));
  }
  const columns = [
    {
      name: "Employee-Id",
      selector: (row) => row?.age,
      sortable: true
    },
    {
      name: "Name",
      selector: (row) => row?.username,
      sortable: true
    },
    
    {
      name: "Number",
      selector: (row) => row?.number,
      
    },
    {
      name: "Branch",
      selector: (row) => row?.branch,
      
    },
    
    {
      name: "Designation",
      selector: (row) => row?.designation,
    },
    {
      name: "Gender",
      selector: (row) => row?.gender,
    },
    {
      name: "Role(s)",
      selector: (row) => row?.roles,
      sortable: true,
      cell: (row) => <span>{row?.roles?.join(", ")}</span>
    },
    {
      name: "Active-Status",
      selector: (row) => row?.status,
      sortable: true,
    },   
    {
      name: "Actions",
      sortable: false,
           
      cell: (row) => [
        <div className='task-icon'
        
        >
        <FaEdit
        
        onClick={handleEditUser.bind(this,row?._id)}
      ></FaEdit></div>,
      
      <div className='task-icon'>
      <FaTrash 
        
        onClick={handleDeleteUser.bind(this,row?._id)}
        
      ></FaTrash> </div> ,
      
      <div className='task-icon'>
        {row.status == "active" ?
            <FaBan  onClick={handleSuspendUser.bind(this,row?._id, 0)} /> :
            <FaCheck  onClick={handleSuspendUser.bind(this,row?._id, 1)} />
        }
      </div>
      ]
    },
    /*
    {
      name: "Action",
      sortable: false,
      selector: "null",
      
      cell: (d) => [
        <div className='btn-container'>
                      <button onClick={
                          (e) =>
                            handleCellEditClick(this)
                      }>
                          Edit
                      </button>
                      <button onClick={
                          (e) =>
                            handleCellDeleteClick(this)
                      }>
                          Delete
                      </button>
                  </div>
      ]
    }*/
  ];
  
      //const data = users;
      const tableData = {
        columns:columns,
        data:users
      };
    // A super simple expandable component.
      const ExpandedComponent = ({ users }) => <pre>{JSON.stringify(users, null, 2)}</pre>;
  
      const getUsers = 
        () => {
            api.get(`${process.env.REACT_APP_URL}/users/all`)
                .then(response => { 
                  //console.log("from mongo fetch",response.data);
                  setUsers(response.data)
                })
                .catch(error =>
                    console.error('Error fetching users:', error));
        };

    const handleAddUser =
        (e) => {
            e.preventDefault();

            api.post(
            `${process.env.REACT_APP_URL}/register`, newUser)
                .then(response => {
                    //console.log(response.data);
                    alert("User added successfuly");
                    handleClose();
                    //setUsers([...users, response.data]);
                    //setNewUser({});// name: '', age: '', gender: '' });
                })
                .catch(error =>
                    alert('Error adding user'));
        };

    const handleSuspendUser =
       (id, activate) => {
          //console.log(users, columns, id);
           var sel = users.find((user) => {
              return (user._id == id )
            });
            sel["status"] = (activate == 1) ? "active": "inactive";
            setSelectedUser(sel);
            setSendUpdate(true);
            //handleUpdateUser(id, sel);
    };

    useEffect(() => {
        if (sendUpdate == true){
              let u = selectedUser;
              u["name"] = auth.username; 
              api.post(
              `${process.env.REACT_APP_URL}/users/update/${selectedUser._id}`, u)
                .then(response => {
                   // setIsEditMode(false); // Switch back to Add mode
                   alert("User updated");
                    handleClose();
                })
                .catch(
                    error =>
                        console.error('Error updating user:', error));
        }
    }, [sendUpdate]);

    const handleUpdateUser = (id) => {
            //e.preventDefault();
            console.log("User to be updated = ", selectedUser, id);
           
            setSendUpdate(true);
    };

    const handleDeleteUser =
      (id) => {

        if (!window.confirm("Are you sure, you want to delete ?"))
          return;
        
        setSelectedUser(null);
        setIsModalOpen(false);
        setIsEditMode(false);
                //confirm("Are you sure you want to delete this entry ?");
        api.delete(
           `${process.env.REACT_APP_URL}/users/delete/${id}`)
                    .then(response => {
                  //console.log(response.data);
                  setSelectedUser(null);
                  setUsers(
                      users.filter(
                          user => user._id !== id));
              })
              .catch(
                  error =>
                      console.error('Error deleting user:', error));
      };

const handleEditUser = (id) => {
console.log(id);
 let u = users.find((user) => {
    return (user._id == id )
  });
  setSelectedUser(u);
  setIsModalOpen(true);
  setIsEditMode(true); // Switch to Edit mode
}

const handleAddNewUser = (e) => {
  e.preventDefault();

  setSelectedUser(null);
  setIsEditMode(false); // Switch to Add mode
  setIsModalOpen(true);
}

const handleClose = () => {
  setIsModalOpen(false);
  setIsEditMode(false);
  getUsers();
  setSelectedUser(null);
  
}

  return (
          <div>
    {isModalOpen ? (
      <div>
           <div className='tableheaderActions'>
      
           <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
           onClick={handleClose}
           > Close</button>
         </div>
         
        <div className='user-main  '>
            <div className='form-sections  '>
                <h4>
                    {
                        isEditMode ?
                            'Edit User' :
                            'Add New User'
                    }
                </h4>
                <form onSubmit=
                    {
                        isEditMode ?
                            (e) =>
                                handleUpdateUser(selectedUser?._id, null) :
                            handleAddUser}>
                              <div className='ele'>
                                      <label>Branch: </label>
                                    <select
                                            value=
                                            {
                                                isEditMode ?
                                                    selectedUser.branch : newUser?.branch
                                            }
                                            onChange={
                                                (e) =>
                                                    isEditMode ?
                                                        setSelectedUser(
                                                            {
                                                                ...selectedUser,
                                                                branch: e.target.value
                                                            }) :
                                                        setNewUser(
                                                            {
                                                                ...newUser,
                                                                branch: e.target.value
                                                            }
                                                        )} 
                                                        >                                                                
                                                        <option value="selectB">Select Branch</option>
                                                        {branches?.map((e, key) => {
                                                            return <option key={e.name} value={e.name}>{e.name}</option>;
                                                        })}
                                    </select>
                                  <br />
                        
                    <label>Name: </label>
                    <input type="text"
                        value={
                            isEditMode ?
                                selectedUser?.username :
                                newUser?.username
                        }
                        onChange={
                            (e) =>
                                isEditMode
                                    ? setSelectedUser(
                                        {
                                            ...selectedUser,
                                            username: e.target.value
                                        }) :
                                    setNewUser(
                                        {
                                            ...newUser,
                                            username: e.target.value
                                        }
                                    )} />
                    <br />
                    <label>Number: </label>
                    <input type="text"
                        value={
                            isEditMode ?
                                selectedUser?.number :
                                newUser?.number
                        }
                        onChange={
                            (e) =>
                                isEditMode
                                    ? setSelectedUser(
                                        {
                                            ...selectedUser,
                                            number: e.target.value
                                        }) :
                                    setNewUser(
                                        {
                                            ...newUser,
                                            number: e.target.value
                                        }
                                    )} />
                    <br />
                    </div>
                    <div className='ele'>
                       <label>Gender: </label>
                                  <select
                                      value=
                                      {
                                          isEditMode ?
                                              selectedUser.gender : newUser?.gender
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedUser(
                                                      {
                                                          ...selectedUser,
                                                          gender: e.target.value
                                                      }) :
                                                  setNewUser(
                                                      {
                                                          ...newUser,
                                                          gender: e.target.value
                                                      }
                                                  )} 
                                                                                                                  
                                        >
                                          <option value="male">Male</option>
                                          <option value="female">Female</option>
                                          <option value="noanswer">Prefer Not to answer</option>
                                        </select>
                    <br/>
                               <label>Status: </label>
                                  <select
                                      value=
                                      {
                                          isEditMode ?
                                              selectedUser.status : newUser?.status
                                      }
                                      onChange={
                                          (e) =>
                                              isEditMode ?
                                                  setSelectedUser(
                                                      {
                                                          ...selectedUser,
                                                          status: e.target.value
                                                      }) :
                                                  setNewUser(
                                                      {
                                                          ...newUser,
                                                          status: e.target.value
                                                      }
                                                  )} 
                                                                                                                  
                                        >
                                          <option value="inactive">Inactive</option>
                                          <option value="active">Active</option>
                                          
                                        </select>
                    <br />
                    <label>Password: </label>
                    <input type="text"
                        value=
                        {
                            isEditMode ?
                                selectedUser?.password : newUser?.password
                        }
                        onChange={
                            (e) =>
                                isEditMode ?
                                    setSelectedUser(
                                        {
                                            ...selectedUser,
                                            password: e.target.value
                                        }) :
                                    setNewUser(
                                        {
                                            ...newUser,
                                            password: e.target.value
                                        }
                                    )} />
                    <br />
                     </div>

                          <div className='ele'>
                       <label>Desgination: </label>
                    <input type="text"
                        value={
                            isEditMode ?
                                selectedUser?.designation :
                                newUser?.designation
                        }
                        onChange={
                            (e) =>
                                isEditMode
                                    ? setSelectedUser(
                                        {
                                            ...selectedUser,
                                            designation: e.target.value
                                        }) :
                                    setNewUser(
                                        {
                                            ...newUser,
                                            designation: e.target.value
                                        }
                                    )} />
                    <br />
                       <label>Roles/Permissions:</label>
                    <div style={{ display: 'grid', gridTemplateColumns: "1fr 1fr 1fr", gap: '6px' }}>
                      {(roles || []).map((role) => {
                        // Determine which user's roles we're dealing with
                        const currentRoles = isEditMode ? selectedUser.roles || [] : newUser?.roles || [];

                        // Check if role is already selected
                        const rtype = role.rtype;
                        const isChecked = currentRoles.includes(rtype);

                        return (
                          <label key={rtype}>
                            <input
                              type="checkbox"
                              value={rtype}
                              checked={isChecked}
                              onChange={(e) => {
                                const updatedRoles = e.target.checked
                                  ? [...currentRoles, rtype] // Add role if checked
                                  : currentRoles.filter((r) => r !== rtype); // Remove role if unchecked

                                if (isEditMode) {
                                  setSelectedUser({ ...selectedUser, roles: updatedRoles });
                                } else {
                                  setNewUser({ ...newUser, roles: updatedRoles });
                                }
                              }}
                            />
                            {rtype.charAt(0).toUpperCase() + rtype.slice(1)}
                          </label>
                        );
                      })}
                    </div>
                      </div>
                    <div className='ele'>
                   
                    <button type="submit">
                        {
                            isEditMode ?
                                'Update User' :
                                'Add User'
                        }
                    </button>
                    </div>
                  
                </form>
            </div>
        </div>
    

        </div>) 
      : 
      ( 
      <div> 
        <div className='tableheaderActions'>
      
          <button id="cnew" type="button" className='btn btn-outline-primary' aria-label='Add New'
            onClick={handleAddNewUser}
          > Add New</button>

        </div>
     
      <DataTableExtensions {...tableData} filter={true} filterLabel={false}>
        <DataTable columns={columns} data={users} 
       // selectableRows 
        pagination
        highlightOnHover	
        header="Table header"
        striped	
        pointerOnHover	
        dense	
        paginationPerPage={100} 
   persistTableHead	
        fixedHeader	
        fixedHeaderScrollHeight='300px' 
        //progressPending	
        defaultSortField="id"
        
        defaultSortAsc={true}
        direction
        expandableRows
        expandableRowsComponent={ExpandedComponent} />
      </DataTableExtensions>
      
       {/*
      {!chatOpen && (
        <FloatingChatBot
          onOpen={() => setChatOpen(true)}
        />
      )}

      {chatOpen && (
        <Chat
          isOpen={chatOpen}
          onClose={() => setChatOpen(false)}
        />
      )} */}
      
</div>
)}
</div>
  );
}
export default Staff;